module.exports = "Github Corner\n===\n\nA react component based on: [https://github.com/tholman/github-corners](https://github.com/tholman/github-corners)\n"


//////////////////
// WEBPACK FOOTER
// ./src/GithubCorner/README.md
// module id = 152
// module chunks = 0